<ui-tabs>
  <ui-tab-item [tabName]="'Administration des plans de prévention'" [templateRef]="pdpTemplate"></ui-tab-item>
  <ui-tab-item [tabName]="'Administration des documents Personne avertie'" [templateRef]="paTemplate"></ui-tab-item>
</ui-tabs>

<ng-template #pdpTemplate >
  <plan-preventions></plan-preventions>
</ng-template>

<ng-template #paTemplate >
  <gestion-documents-pa></gestion-documents-pa>
</ng-template>
